import { makeRPCPost } from '~api/RpcAPI/RpcAPI';
import { IRemoveKitPayload } from '~api/KitsAPI/IKitsAPI';

export const removeKitItem = async ({
    cartId,
    collection: { id, name, type, subtype },
    skuId
}: IRemoveKitPayload) => {
    const body = [
        {
            method: 'rpc.form',
            params: [
                {
                    cmode: 'del',
                    _SUBMIT: 'cart',
                    CART_ID: cartId,
                    QTY: 0,
                    COLLECTION_ID: id,
                    COLLECTION_NAME: name,
                    COLLECTION_TYPE: type,
                    COLLECTION_SUBTYPE: subtype,
                    SKU_BASE_ID: skuId
                }
            ]
        }
    ];

    return makeRPCPost(body);
};
